export const mockAPIPath = {
    UNREGISTERED_IMAGE_LIST:"./data/UnregisteredImageList.json"
};

export const serverAPIPath = {
    PRODUCTS_LIST : "/products",
    UNREGISTERED_IMAGE_LIST:"/products/unregistered-images",
    REFRESH_URL:"/products/unregistered-images/tracking"
};